import { AppState } from "./types";

const selectors = {
  getActiveSheet(state: AppState) {
    return state.sheets[0];
  }
};

export default selectors;
